import React from 'react';
import { connect } from 'react-redux';
import pushLocation from 'utils/pushLocation';
import uid from 'utils/uid';
import { ArrowForward } from 'core/icons';
import { SiteContainer } from 'core/layout';
import { Card, Hairline, BreadcrumbsConnected } from 'elements';
import { Swiper } from 'modules';
import {
  Section,
  SectionHeading,
  CardsWrapper,
  HalfFlex,
  ThirdFlex,
  SwiperButtonNext,
  SwiperButtonPrev,
  RelatedGroup,
} from './styled';
import transformData from './transformData';

class Apakskategorija extends React.Component {
  render() {
    const data = transformData(this.props.data);
    const layout = this.props.breakpoint;

    const layoutProps = {
      compact: layout !== 'desktop'
    };

    const renderCard = (item, ofTypeLink) => {
      const commonProps = Object.assign({},
        layoutProps,
        {
          title: item.title,
          link: item.location,
          target: item.target,
        }
      );
      if (ofTypeLink) {
        commonProps.type = 'link';
      } else {
        commonProps.description = item.description;
      }
      return (
        <Card
          {...commonProps}
        />
      );
    };

    const relatedSectionId = 'saistitie_pakalpojumi';
    const hasRelatedSection = data.sections.hasOwnProperty(relatedSectionId) &&
      data.sections[relatedSectionId] !== false;

    const renderSection = (data, teksti, isRelatedSection) => {
      if (data === false) {
        return null;
      }

      const cardOfTypeLink = hasRelatedSection && !isRelatedSection;
      const stretchCards = cardOfTypeLink || !hasRelatedSection;

      const FlexItem = cardOfTypeLink ? HalfFlex : ThirdFlex;

      const primaryCards = (
        <CardsWrapper
          stretchCards={stretchCards}
        >
          {
            data.items.map(item => (
              <FlexItem key={uid()}>
                {
                  renderCard(item, cardOfTypeLink)
                }
              </FlexItem>
            ))
          }
        </CardsWrapper>
      );

      const swiperNavigationProps = {
        type: 'text',
        icon: ArrowForward,
        onClick: () => {},
      };

      let relatedCards;
      if (isRelatedSection) {
        const cardSlides = data.items.map(item => renderCard(item, cardOfTypeLink));
        relatedCards = (
          <RelatedGroup>
            <Swiper
              slides={cardSlides}
              slidesPerView={3}
              spaceBetween={24}
              nextButton={
                <SwiperButtonNext
                  {...swiperNavigationProps}
                />
              }
              prevButton={
                <SwiperButtonPrev
                  {...swiperNavigationProps}
                />
              }
              teksti={teksti}
            />
          </RelatedGroup>
        );
      }

      return (
        <Section key={uid()}>
          <SectionHeading level={2}>
            {data.title}
          </SectionHeading>
          {
            isRelatedSection ? relatedCards : primaryCards
          }
        </Section>
      );
    };

    const sectionKeys = Object.keys(data.sections);

    return (
      <div>
        <SiteContainer>
          <BreadcrumbsConnected
            lang={this.props.lang}
            path={this.props.path}
          />
        </SiteContainer>

        <main>
          <SiteContainer>
            {
              sectionKeys.map((key, i) => {
                const section = renderSection(
                  data.sections[key],
                  data.teksti,
                  key === relatedSectionId
                );

                if (i < sectionKeys.length - 1) {
                  return [
                    section, <Hairline key={uid()} />
                  ];
                } else {
                  return section;
                }
              })
            }
          </SiteContainer>
        </main>
      </div>
    );
  }
}

const mapStateToProps = ({breakpoint}) => ({
  breakpoint
});

export default connect(mapStateToProps)(Apakskategorija)



// WEBPACK FOOTER //
// ./src/pages/Apakskategorija/Apakskategorija.jsx